import { createFileRoute } from '@tanstack/react-router';
import { TransactionalOverviewIndexRoute } from '@/pages/workspaces/transactional/message/overview/index-tab/routing';

function TransactionalOverviewIndexRouteComponent() {
  const { transactionalMessageId } = Route.useParams();
  return <TransactionalOverviewIndexRoute transactionalMessageId={transactionalMessageId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/',
)({
  component: TransactionalOverviewIndexRouteComponent,
});
